global.DmStyleProvider = require('../Theme/utils');
global.DmStyleConfig = require('../Theme/utils/styleConfig');

global.BodyScrollLock = require('body-scroll-lock');
global.ReactFocusLock = require('react-focus-lock');
global.ReactTransitionGroup = require('react-transition-group');
